// extracted by mini-css-extract-plugin
export default {"success":"index_success__W+YNu","box":"index_box__EjUVY"};